import React, { FC, useEffect, useMemo } from 'react'
import { Button, Drawer, DrawerCloseButton, DrawerContent, DrawerOverlay, useDisclosure } from '@chakra-ui/react'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import CostCenterCard from 'InstitutionalManagement/components/CostCenterCard'
import SearchCostCenterOnCustomForm from './components/SearchCostCenterOnCustomForm'
import SelectCostCenterOnCustomForm from './components/SelectCostCenterOnCustomForm'
import { useCustomFormCostCenterSelectionDrawerManager } from './contexts/CustomFormCostCenterSelectionDrawerManager/Provider'
import useGetCostCenterByID from 'components/tools/CustomForm/components/Viewer/hooks/useGetCostCenterByID'

type Views = {
  [key: string]: JSX.Element
}

type Props = {
  question: CustomFormQuestion
  disabled?: boolean
}

const CustomFormCostCenterSelectionDrawerContent: FC<Props> = ({ question, disabled }) => {
  const { isOpen, onClose, onOpen } = useDisclosure()

  const { getCostCenter, loadingCostCenter } = useGetCostCenterByID()

  const { selectedCostCenter, setSelectedCostCenter, view, filter } = useCustomFormCostCenterSelectionDrawerManager()

  const RenderComponent = useMemo(() => {
    const views: Views = {
      SEARCH_COST_CENTER: <SearchCostCenterOnCustomForm onClose={onClose} />,
      SELECT_COST_CENTER: <SelectCostCenterOnCustomForm onClose={onClose} />,
    }

    return views[view]
  }, [filter, view])

  async function loadCostCenter(costCenterId: string) {
    const costCenterFromAPI = await getCostCenter(costCenterId)
    setSelectedCostCenter(costCenterFromAPI)
  }

  useEffect(() => {
    async function loadAsyncFunction() {
      if (question.default_value && question.default_value.length > 0) {
        const costCenterId = question.default_value[0]
        await loadCostCenter(costCenterId)
      }
      if (question.answer && question.answer.length > 0) {
        const costCenterId = question.answer[0]
        await loadCostCenter(costCenterId)
      }
    }
    loadAsyncFunction()
  }, [question])

  return (
    <>
      <Button
        isLoading={loadingCostCenter}
        minWidth="100%"
        variant="outline"
        isDisabled={disabled}
        width="max-content"
        onClick={onOpen}
      >
        {selectedCostCenter?.id ? 'Atualizar centro de custo' : 'Adicionar centro de custo'}
      </Button>

      {selectedCostCenter?.id && (
        <CostCenterCard costCenter={selectedCostCenter} borderWidth="1px" borderColor="borderColor" />
      )}

      <Drawer isOpen={isOpen} onClose={onClose}>
        <DrawerOverlay />

        <DrawerContent>
          <DrawerCloseButton />

          {RenderComponent}
        </DrawerContent>
      </Drawer>
    </>
  )
}

export default CustomFormCostCenterSelectionDrawerContent
